import { getSingleBetProps, getComboBetProps, getYourBetProps, getSystemBetProps, getPulseBetProps, getCastBetProps, getTeaserBetProps } from "../helpers/templates";
export const BetTemplateProps = {
    Single: getSingleBetProps,
    Combo: getComboBetProps,
    System: getSystemBetProps,
    YourBet: getYourBetProps,
    PulseBet: getPulseBetProps,
    CastBet: getCastBetProps,
    Teaser: getTeaserBetProps
};
//# sourceMappingURL=BetTemplateProps.js.map